import React, {useState} from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text, Button, TableContainer, Table, Thead, Tr, Th, Tbody, Td, Box, Tooltip, HStack
} from "@chakra-ui/react";
import {event} from "../../../../services/analytics";
import {shouldDeliverPage} from "@app/core-app/app/domain/notion/properties";
import {PageData} from "@app/core-app/app/usecase/notion/fetch-pages";
import {IconLink} from "../../atoms/IconLink";
import {useAllDatabasePages} from "../../../../data/pages";
import {InfoOutlineIcon} from "@chakra-ui/icons";

export const OutboxPagesModal = ({onPagePreview, onPageSend, databaseId}: any) => {

  const [isOpen, setIsOpen] = useState(false);
  const [progressing, setProgressing] = useState(false)

  const [displayCount, setDisplayCount] = useState(10);

  const handleShowMore = () => {
    setDisplayCount(prevCount => prevCount + 15);
  };

  const {data, isLoading} = useAllDatabasePages(databaseId)

  const onOpen = () => {
    event({action: "open_outbox_pages_modal", params: {}})
    setIsOpen(true);
  }

  const onClose = () => {
    setIsOpen(false);
  };

  return (<>
    <Button onClick={() => onOpen()} colorScheme={"blue"} size={"sm"} variant={"outline"}>
        View all pages
    </Button>
    <Modal isOpen={isOpen} onClose={onClose} size={"6xl"}>
      <ModalOverlay/>
      <ModalContent>
        <ModalHeader>Email List</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>

          <Box>
            <TableContainer>
              <Table variant="simple" size="sm">
                <Thead>
                  <Tr>
                    <Th w={1}>No.</Th>
                    <Th w={1}>Page Title</Th>
                    <Th>Subject</Th>
                    <Th w={1}>Recipients</Th>
                    <Th w={1}>Open</Th>
                    <Th w={1}></Th>
                    <Th w={1}></Th>

                  </Tr>
                </Thead>
                <Tbody>
                  {data?.slice(0, displayCount)?.map((page: PageData, index) => {
                    const recipientsExists = page?.recipients?.length

                    const hasToBeDelivered = shouldDeliverPage(page)
                    return <Tr key={index}>
                      <Td>{index + 1}</Td>
                      <Td><Text>{page.title}</Text></Td>

                      <Td>{page.subject}</Td>
                      <Td isNumeric>
                        <Tooltip label={page?.recipients?.join(", ")} fontSize={"xs"}>
                          <HStack spacing={1}>
                            <span>{page?.recipients?.length}</span>
                            <InfoOutlineIcon fontSize={"xs"}/>
                          </HStack>
                        </Tooltip>
                      </Td>
                      <Td>
                        {page.url &&
                          <IconLink url={page.url}/>
                        }
                      </Td>

                      <Td>
                        <Button
                          variant={"link"}
                          colorScheme={"blue"}
                          size={"sm"}
                          onClick={() => {
                            if (onPagePreview) {
                              event({action: "preview_page_click", params: {title: page.title, id: page.id}})
                              onPagePreview(page)
                            }
                          }}>
                          <span>Preview</span>
                        </Button>
                      </Td>

                      <Td>
                        {
                          page.readyToSend && !page.sent && <Button
                            isLoading={progressing}
                            variant={"outline"}
                            colorScheme={"blue"}
                            size={"sm"}
                            onClick={() => {
                              if (onPageSend) {
                                event({action: "send_page_manually_click", params: {title: page.title, id: page.id}})
                                setProgressing(true)
                                onPageSend(page)
                                  .then(() => setProgressing(false))
                              }
                            }}
                          >
                            <span> Send </span>
                          </Button>
                        }
                      </Td>
                    </Tr>
                  })}

                </Tbody>
              </Table>
            </TableContainer>
          </Box>
          {data && displayCount < data.length && (
            <Button size="sm" colorScheme={"blue"} variant={"outline"} onClick={handleShowMore} mt={4}>
              Show More
            </Button>
          )}

        </ModalBody>
      </ModalContent>
    </Modal>
  </>
  );
};
